import { AppointmentSmartSuggestModel, AppointmentSmartSuggestionModel } from ".";
export interface IAppointmentSmartSearchParameterModel {
    InputEntries: AppointmentSmartSuggestModel[];
    RegionEntries: AppointmentSmartSuggestionModel[];
    Input: string;
    FieldId: number;
    FieldCategory: string;
    Ids:number[];
    IsDeleted?: boolean;
    UserIds:number[];
    WebAppDateFrom: string;
    WebAppDateTo: string;
    Year: number;
}
export class AppointmentSmartSearchParameterModel {

    InputEntries: AppointmentSmartSuggestModel[];
    RegionEntries: AppointmentSmartSuggestionModel[];
    Input: string;
    FieldId: number;
    FieldCategory: string;
    Ids:number[];
    IsDeleted?: boolean;
    UserIds:number[];
    WebAppDateFrom: string;
    WebAppDateTo: string;
    Year: number;
    /**
     *
     */
    constructor(option?: IAppointmentSmartSearchParameterModel) {
        if (option != null) {
            Object.keys(option).forEach((key) => {
                this[key] = option[key]
            })
        }
    }
}